const foodsuggestion = {
  getlist: 'foodsuggestion/getlist-by-admin',
  add: 'foodsuggestion/add',
  update: 'foodsuggestion/update',
  remove: 'foodsuggestion/remove',
  get: 'foodsuggestion/get',
}
export default foodsuggestion
